import React from 'react';
import PropTypes from 'prop-types';
import { pick, noop } from 'lodash';
import { LayoutListener } from '@dbk/ui-responsive';
import { View } from '@dbk/ui-react-utils';
import { propTypes, contextTypes, privateOrientationType } from '../common';
import Arrow from './arrow';
import CloseBtn from './close-btn';
import * as styles from './styles';

export default class PopoverContentContainer extends React.Component {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
      .isRequired,
    onMouseLeave: PropTypes.func,
    onHide: PropTypes.func.isRequired,
    closing: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    orientation: privateOrientationType,
    ...pick(propTypes, [
      'popOverClassName',
      'position',
      'showCloseButton',
      'mode',
      'id',
      'testID',
    ]),
  };
  static defaultProps = {
    onMouseLeave: noop,
    orientation: '',
  };
  static contextTypes = contextTypes;

  constructor() {
    super();
    this.state = {
      contentHeight: undefined,
    };
  }
  setContentHeight = ({ height }) => {
    this.setState({
      contentHeight: height + 1,
    });
  };

  getContent = () => {
    /* eslint-disable jsx-a11y/anchor-has-content, jsx-a11y/no-static-element-interactions */
    const {
      mode,
      orientation,
      children,
      showCloseButton,
      popOverClassName,
      onHide,
      type,
    } = this.props;
    const classes = styles.getContentWrapperClassNames(
      orientation,
      popOverClassName,
      showCloseButton,
      this.context.inverse,
      type
    );
    return (
      <LayoutListener
        style={styles.getWidth(mode, orientation)}
        className={classes}
        onLayout={this.setContentHeight}
      >
        {showCloseButton && <CloseBtn onClick={onHide} />}
        {children}
      </LayoutListener>
    );
  };

  render() {
    const {
      orientation,
      position,
      type,
      onMouseLeave,
      closing,
      id,
      mode,
      testID,
      arrowColor
    } = this.props;
    const content = this.getContent();
    const classes = styles.getContainerWrapperClassNames(
      closing,
      mode,
      orientation
    );
    return (
      <View
        className={classes}
        onMouseLeave={onMouseLeave}
        aria-hidden={closing}
        aria-describedby={id}
        data-test-id={testID}
      >
        <Arrow
          orientation={orientation}
          position={position}
          bottomEdge={this.state.contentHeight}
          type={type}
          arrowColor={arrowColor}
        />
        {content}
      </View>
    );
  }
}
